var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.ratingTemplate.type === _vm.RATING_TEMPLATE_TYPE.STAR ? _c('RatingStar', {
    attrs: {
      "ratingTemplate": _vm.ratingTemplate
    },
    on: {
      "sendMessage": _vm.sendCustomMessage
    }
  }) : _c('RatingNumber', {
    attrs: {
      "ratingTemplate": _vm.ratingTemplate
    },
    on: {
      "sendMessage": _vm.sendCustomMessage
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }